import { useState } from "react";
import type { ReactNode } from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import SbuxTranslate from "../SbuxTranslate";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import styles from "./styles";
import useCss from "../../hooks/useCss";

export interface ButtonItem {
  value: string | number;
  name: string;
  disabled?: boolean;
  toolTipMsg?: ReactNode;
}

interface Props {
  buttonList: ButtonItem[];
  value: string;
  handleButtonToggle: (val: string) => void;
}

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 200,
  },
});

const SbuxButtonGroup = ({ buttonList, value, handleButtonToggle }: Props) => {
  const classes = useCss(styles);
  const [buttonValue, setButtonValue] = useState(value);

  const handleToggle = (
    _event: React.MouseEvent<HTMLElement>,
    newValue: string,
    isDisabled?: boolean,
  ) => {
    if (isDisabled === undefined || isDisabled === false) {
      handleButtonToggle(newValue);
      setButtonValue(newValue);
    }
  };

  return (
    <ToggleButtonGroup
      sx={{ display: "flex", width: "40%" }}
      value={buttonValue}
      exclusive
    >
      {buttonList &&
        buttonList.length > 0 &&
        buttonList.map((item, index) => {
          const buttonStyles = [classes.toggleButton];
          if (String(buttonValue) === String(item.value)) {
            buttonStyles.push(classes.active);
          }
          if (item.disabled) {
            buttonStyles.push(classes.disabled);
          }

          return (
            <CustomWidthTooltip
              title={
                item.disabled ? (
                  <span style={{ fontSize: 14 }}>{item.toolTipMsg}</span>
                ) : (
                  ""
                )
              }
              placement="right"
              key={index}
            >
              <ToggleButton
                onChange={(event, newValue) =>
                  handleToggle(event, newValue, item.disabled)
                }
                value={item.value}
                size="small"
                key={index}
                className={buttonStyles.join(" ")}
                selected={String(buttonValue) === String(item.value)}
              >
                <SbuxTranslate>{item.name}</SbuxTranslate>
              </ToggleButton>
            </CustomWidthTooltip>
          );
        })}
    </ToggleButtonGroup>
  );
};

export default SbuxButtonGroup;
